import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/galerie',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::index
* @see app/Http/Controllers/Public/GalleryController.php:53
* @route '/galerie'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
export const show = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/galerie/{gallery}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
show.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return show.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
show.get = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
show.head = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
const showForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
showForm.get = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\GalleryController::show
* @see app/Http/Controllers/Public/GalleryController.php:122
* @route '/galerie/{gallery}'
*/
showForm.head = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
export const photo = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: photo.url(args, options),
    method: 'get',
})

photo.definition = {
    methods: ["get","head"],
    url: '/galerie/{gallery}/fotka/{photo}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
photo.url = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
            photo: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
    }

    return photo.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace('{photo}', parsedArgs.photo.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
photo.get = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: photo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
photo.head = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: photo.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
const photoForm = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: photo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
photoForm.get = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: photo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\PhotoController::photo
* @see app/Http/Controllers/Public/PhotoController.php:25
* @route '/galerie/{gallery}/fotka/{photo}'
*/
photoForm.head = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: photo.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

photo.form = photoForm

const galleries = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    photo: Object.assign(photo, photo),
}

export default galleries